import React from 'react';
import {Row, Col, Card} from 'react-materialize';

import hierarchy from '../../images/hierarchy_control.png';
import workplace from '../../images/workplace.png';
import yourself from '../../images/yourself_protection.png';

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"protection_title"} defaultMessage={"Proteção"}/></b></p></h5>
            </div>
        </Row>

        <Row align="center">
            
                <div align="center" style={{margin:"25px"}}>
                    <a href={"/hierarchy_protection"} style={{background:'white', color: 'black'}}>
                        <img src={hierarchy} className={"img"} alt={"O que é SARS-COV-2?"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"hierarchy_protection_title"} defaultMessage={"Como proteger o local de trabalho e os trabalhadores usando a hierarquia de controles?"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"25px"}}>
                    <a href={"/workplace_protection"} style={{background:'white', color: 'black'}}>
                        <img src={workplace} className={"img"} alt={"Sintomas"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"workplace_protection_title"} defaultMessage={"Como empregadores podem melhorar a segurança do local de trabalho?"}/></b></p>
                    </a>
                </div>
                <div align="center" style={{margin:"25px"}}>
                    <a href={"/yourself_protection"} style={{background:'white', color: 'black'}}>
                        <img src={yourself} className={"img"} alt={"Sintomas"} width={"auto"} height={"auto"}/>
                        <p><b><FormattedMessage id={"yourself_protection_title"} defaultMessage={"Como se proteger?"}/></b></p>
                    </a>
                </div>
        </Row>

        <Row align="center">
            <div align="center">
                <a href={"/covid"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>
    </Card>

);

export default Sobre;